var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { nl2br, targetBlankifyLinks } from '../../../lib/helpers';
import { strings } from '../../../lib/localization';
import { useEffect, useRef } from 'react';
export var AlertField = function (_a) {
    var data = _a.data, localizationFormatValues = _a.localizationFormatValues, handleAlertLinkClick = _a.handleAlertLinkClick;
    var alertRef = useRef(null);
    var formatted = strings.formatString(data.value, localizationFormatValues);
    var handleArticleLinkClick = function (e) {
        e.preventDefault();
        var target = e.target;
        var articleId = Number(target.getAttribute('data-articleid'));
        if (handleAlertLinkClick) {
            handleAlertLinkClick(articleId);
        }
    };
    var injectArticleLinks = function () {
        if (alertRef.current) {
            var articleLinks = alertRef.current.querySelectorAll('[data-articleid]');
            for (var i = 0; i < articleLinks.length; i++) {
                articleLinks[i].addEventListener('click', handleArticleLinkClick);
            }
        }
    };
    var removeInjectedArticleLinks = function () {
        if (alertRef.current) {
            var articleLinks = alertRef.current.querySelectorAll('[data-articleid]');
            for (var i = 0; i < articleLinks.length; i++) {
                articleLinks[i].removeEventListener('click', handleArticleLinkClick);
            }
        }
    };
    useEffect(function () {
        injectArticleLinks();
        return function () {
            removeInjectedArticleLinks();
        };
    }, []);
    var content;
    if (data.usesHtml) {
        content = {
            __html: targetBlankifyLinks(formatted),
        };
    }
    else {
        content = {
            __html: nl2br(targetBlankifyLinks(formatted)),
        };
    }
    return (_jsx("div", __assign({ className: data.className ? data.className : 'col-xs-12' }, { children: _jsx("div", { ref: alertRef, className: data.type ? data.type + ' alert' : 'alert', id: data.qid, dir: "auto", dangerouslySetInnerHTML: content }, void 0) }), data.qid));
};
